// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    development: false,
    local: false,
    test: true,
    uat:false
  };
  
  export const API_BASE_URL = "https://app.carstest.us-west-2.int.fti-cloud.com/cars/api/v1.0"

  export const UPLOAD_FILE_BASE_URL = "/dataloads/s3_upload"
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */ 
  import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  